import { REGULAR_PRODUCT } from '../components/constants'

export default function getProductDrop(product) {
    return product?.drop || {}
}